export default {

  header: {
    'black': { url: `${process.env.BASE_URL}images/glxp/black.png`, options: [] }
  },

  transition: {
    'black': { url: `${process.env.BASE_URL}images/glxp/black.png`, options: [] },
    'shake': { url: `${process.env.BASE_URL}images/glxp/transition-shake.png`, options: [] }
  },

  home: {
    'shake': { url: `${process.env.BASE_URL}images/glxp/home-shake.jpg`, options: ['clamp'] },
    'test': { url: `${process.env.BASE_URL}images/glxp/UV_Grid.jpg`, options: [] }
  },

  philosophy: {
    'intersection': { url: `${process.env.BASE_URL}images/glxp/intersection.png`, options: ['clamp'] },
    'collaboration': { url: `${process.env.BASE_URL}images/glxp/collaboration.png`, options: ['clamp'] },
    'performance': { url: `${process.env.BASE_URL}images/glxp/performance.png`, options: ['clamp'] }
  }

}
